import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { withEnvironment } from '../extensions/with-environment';
import { IPredictionRecord, PredictionRecord } from '../../models/prediction-record/PredictionRecord';
import { PredictionRecordApi, TGetPredictionRecordsResult } from '../../services';
import { withRootStore } from '../extensions/with-root-store';
/**
 * # PredictionRecordStore
 *
 * PredictionRecordStore을 설명하세요.
 */
export const PredictionRecordStore = types
  .model('PredictionRecordStore')
  // --------------------------------------------------------------------------
  .props({
    predictionRecords: types.optional(types.array(PredictionRecord), []),
  })
  .extend(withEnvironment)
  .extend(withRootStore)
  // eslint-disable-line @typescript-eslint/no-unused-vars
  .views((self) => ({}))
  // --------------------------------------------------------------------------
  // MUTATEs - 모델 상태를 변경
  .actions((self) => ({
    /**
     * predictionRecords을 교체
     *
     * @param `predictionRecords` 새로운 모델의 배열
     */
    setPredictionRecords: (predictionRecords: IPredictionRecord[]) => {
      self.predictionRecords.replace(predictionRecords);
    },
  }))
  // --------------------------------------------------------------------------
  // REQUESTs - 서비스 요청 및 기타 인터페이스 요청
  .actions((self) => ({
    /**
     * 전체 목록을 Api를 통해 조회
     *
     * 조회한 결과로 PredictionRecords를 교체한다. 실패시 에러 로그를 남긴다.
     */
    getPredictionRecordHistory: async (data: any) => {
      try{
        const predictionRecordApi: PredictionRecordApi = new PredictionRecordApi(
          self.environment.api,
        );
        const result: TGetPredictionRecordsResult =
          await predictionRecordApi.getPredictionRecordHistory(data);

        if (self.rootStore.responseStore.getResponseResult(result) && self.rootStore.responseStore.responseInfo.resultCode === 'S') {
          if (result.predictionRecords) {
            self.setPredictionRecords(result.predictionRecords);
          }
        }
      } catch(e) {
        self.rootStore.responseStore.errorProcessing(e);
      }
    },
  }));

// --------------------------------------------------------------------------
type TPredictionRecordStore = Instance<typeof PredictionRecordStore>;
type TPredictionRecordStoreSnapshot = SnapshotOut<typeof PredictionRecordStore>;

export interface IPredictionRecordStore extends TPredictionRecordStore {}
export type TPredictionRecordStoreKeys = keyof TPredictionRecordStoreSnapshot & string;
export interface IPredictionRecordStoreSnapshot extends TPredictionRecordStoreSnapshot {}
export const createPredictionRecordStore = () =>
  types.optional(PredictionRecordStore, {} as TPredictionRecordStore);
